import { render, staticRenderFns } from "./NavigationPage.vue?vue&type=template&id=3be75786&scoped=true"
import script from "./NavigationPage.vue?vue&type=script&lang=js"
export * from "./NavigationPage.vue?vue&type=script&lang=js"
import style0 from "./NavigationPage.vue?vue&type=style&index=0&id=3be75786&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be75786",
  null
  
)

export default component.exports